export { default } from '@components/Heading/Heading'
